<form [formGroup]="form">
  <div class="edit-actions">
    <button matTooltip="Cancelar" type="button" (click)="close()" mat-icon-button class="card-inline">
      <mat-icon>clear</mat-icon>
    </button>
  </div>
  <div class="card-base-actions">
    <div class="card-content-associaton">
      <div class="card-container mat-elevation-z1">
        <div class="card-content">
          <div class="margin-right-small">
            <div class="card-inline">
              <mat-form-field class="margin-right-small">
                <mat-label>Número de factura</mat-label>
                <input type="number" formControlName="Number" matInput>
              </mat-form-field>
              <mat-form-field class="margin-right-small">
                <mat-label>Razón social</mat-label>
                <input type="text" formControlName="BusinessName" matInput>
              </mat-form-field>
              <button class="card-inline" (click)="search()" type="button" mat-mini-fab>
                <mat-icon>search</mat-icon>
              </button>
            </div>
            <mat-divider></mat-divider>
            <div class="aling-top full-width margin-top-medium">
              <mat-spinner *ngIf="loading"></mat-spinner>
              <p-scrollPanel *ngIf="!loading" styleClass="scroll-panel">
                <table class="search-table search-table-fixed" mat-table [dataSource]="dataSource">
                  <ng-container matColumnDef="Number">
                    <th class="search-table-header resizable-column" mat-header-cell *matHeaderCellDef>
                      <resizable-column-control width="100" tile="Numero" #resColNumber></resizable-column-control>
                    </th>
                    <td class="search-table-cell" mat-cell *matCellDef="let element">
                      <div><b>{{element.Number}}</b></div>
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="BusinessName">
                    <th class="search-table-header resizable-column" mat-header-cell *matHeaderCellDef>
                      <resizable-column-control width="100" tile="Razón social" #resColBusinessName></resizable-column-control>
                    </th>
                    <td class="search-table-cell" mat-cell *matCellDef="let element">
                      <div>{{element.BusinessName}}</div>
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="CreateDateView">
                    <th class="search-table-header resizable-column" mat-header-cell *matHeaderCellDef>
                      <resizable-column-control width="50" tile="Fecha" #resColCreateDateView></resizable-column-control>
                    </th>
                    <td class="search-table-cell" mat-cell *matCellDef="let element">
                      <div>{{element.CreateDateView}}</div>
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="Amount">
                    <th class="search-table-header resizable-column" mat-header-cell *matHeaderCellDef>
                      <resizable-column-control width="50" tile="Importe" #resColAmount></resizable-column-control>
                    </th>
                    <td class="search-table-cell" mat-cell *matCellDef="let element">
                      <div>{{element.Amount}}</div>
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="RemainingBalance">
                    <th class="search-table-header resizable-column" mat-header-cell *matHeaderCellDef>
                      <resizable-column-control width="50" tile="Saldo Restante" #resColAmount></resizable-column-control>
                    </th>
                    <td class="search-table-cell" mat-cell *matCellDef="let element">
                      <div>{{element.RemainingBalance}}</div>
                    </td>
                  </ng-container>
                  <!-- Star Column -->
                  <ng-container matColumnDef="Star" stickyEnd>
                    <th class="search-table-header" mat-header-cell *matHeaderCellDef></th>
                    <td class="search-table-cell" mat-cell *matCellDef="let element">
                      <button (click)="associate(element)" mat-icon-button>
                        <mat-icon>add</mat-icon>
                      </button>
                    </td>
                  </ng-container>
                  <tr mat-header-row class="search-table-header" *matHeaderRowDef="displayedColumns; sticky: true"></tr>
                  <tr mat-row class="search-table-cell" *matRowDef="let row; columns: displayedColumns;"></tr>
                </table>
              </p-scrollPanel>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</form>
